import { useState, useEffect, memo, useCallback } from "react";
import { Dropdown } from "primereact/dropdown";
import "./styles.css";

export default memo(function DropdownFilter({
  id,
  labelHead,
  initialData,
  data,
  dataId,
  handleUpdateItems,
  idRow,
  disabled,
  className,
  panelClassName,
  virtualScroll = true,
  filterInputAutoFocus = true,
}: any) {
  //console.log("CHECK DATA DROPDOWN, DATA: ", data + "DATAID: ", dataId);
  const [initialDataLocal] = useState(initialData);
  const [selectedData, setSelectedData] = useState<{
    id: string;
    nombre: string;
  }>({
    id: dataId,
    nombre: data,
  });

  useEffect(() => {
    const obj = {
      id: dataId,
      nombre: data,
    };

    setSelectedData(obj);
  }, []);

  const selectedTemplate = (option: any, props: any) => {
    if (option) {
      return (
        <div id={option.id} className="flex align-items-center">
          <div>{option.nombre}</div>
        </div>
      );
    }
    return <span>{props.placeholder}</span>;
  };

  const optionTemplate = (option: any) => {
    return (
      <div
        id={option.id}
        className="flex align-items-center"
        style={{ width: "100%", height: "100%" }}
      >
        <div style={{ height: "inherit" }}>{option.nombre}</div>
      </div>
    );
  };

  // La notificacion al padre se hace en onChange (y no en el click del template)
  // para que funcione al hacer click en todo el item, con touch/trackpad y con teclado.
  const handleChange = useCallback(
    (e: any) => {
      const item = e.value;
      if (!item) return;
      setSelectedData({
        id: item.id ?? "",
        nombre: item.nombre ?? "",
      });
      handleUpdateItems(item, idRow);
    },
    [handleUpdateItems, idRow],
  );

  return (
    <div className={`card flex justify-content-center ${className ?? ""}`}>
      <label>{labelHead}</label>
      <Dropdown
        id={id}
        disabled={disabled === "" ? null : disabled}
        value={selectedData || data}
        onChange={handleChange}
        options={initialDataLocal}
        optionLabel="nombre"
        placeholder="Seleccione..."
        filter
        filterInputAutoFocus={filterInputAutoFocus}
        panelClassName={panelClassName}
        valueTemplate={selectedTemplate}
        itemTemplate={optionTemplate}
        virtualScrollerOptions={
          virtualScroll ? { itemSize: 35, showLoader: true } : undefined
        }
      />
    </div>
  );
});
